import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function LatestContent() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-10 md:mb-14">
            <div>
              <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
                最新内容
              </h2>
              <p className="text-foreground-600 text-sm md:text-base">
                持续更新的火影同人创作内容，保持你的创作灵感不断线
              </p>
            </div>
            <Link
              to="/category/tongren-xiaoshuo"
              className="hidden sm:flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium whitespace-nowrap transition-colors duration-200"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {latest.map((article) => (
              <ArticleCard key={article.slug} article={article} variant="default" />
            ))}
          </div>
          <div className="mt-8 text-center sm:hidden">
            <Link
              to="/category/tongren-xiaoshuo"
              className="inline-flex items-center gap-1 px-5 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200"
            >
              查看全部文章
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}